
import { Box, Card, CardActionArea, Grid, Typography } from "@mui/material"
import { IOSSwitch } from "../../../theme"



export const SwitchDinamico = ({ titulo, permisoKey, checked, marginbotom=1, paddinY=1, onChange }) => {


    return (

        <Grid item xs={12} sx={{ mb: marginbotom }}>
            <Card elevation={3} sx={{ width: "100%" }}>
                <CardActionArea onClick={() => onChange?.(permisoKey)} >
                    <Box display="flex" justifyContent="space-between" alignItems="center" py={paddinY} px={2}>
                        <Typography variant="h3" sx={{ fontWeight:600 }}>
                            { titulo }
                        </Typography>
                        <IOSSwitch sx={{ m:1 }} checked={checked} onChange={() => onChange?.(permisoKey)} />
                    </Box>
                </CardActionArea>
            </Card>
        </Grid>
    
    )
}
